import React from "react";
import { Button, CircularProgress, createFilterOptions } from "@mui/material";

export const dominioFilterOptions = createFilterOptions({
  stringify: (option) => `${option?.dominio || ""} ${option?.id ?? ""} ${option?.bd || ""}`,
});

export function fmtChargebackLabel(value, t, prefix = "passengerMpChargebackStatus") {
  if (value == null || value === "") return "—";
  const raw = String(value).trim();
  const slug = raw.toLowerCase().replace(/[\s-]+/g, "_");
  return t(`platformPage.${prefix}_${slug}`, {
    defaultValue: raw.replace(/_/g, " "),
  });
}

export function BusyButton({
  loading = false,
  busy = false,
  disabled,
  startIcon,
  children,
  loadingText,
  ...props
}) {
  const isBusy = Boolean(loading || busy);
  const effectiveDisabled = disabled ?? isBusy;
  const effectiveStartIcon = isBusy ? (
    <CircularProgress size={16} color="inherit" />
  ) : (
    startIcon
  );

  return (
    <Button {...props} disabled={effectiveDisabled} startIcon={effectiveStartIcon}>
      {isBusy && loadingText ? loadingText : children}
    </Button>
  );
}
